// extracted by mini-css-extract-plugin
export var cancelButton = "_m0-5";
export var content = "_m0-3";
export var createButton = "_m0-6";
export var drawerContainer = "_m0-0";
export var footer = "_m0-2";
export var header = "_m0-1";
export var orderFormColumn = "_m0-4";